import { graphql } from "gatsby";
import React from "react";
import { twJoin } from "tailwind-merge";

import Breakpoint from "../breakpoint";
import Image from "../image";
import RichText from "../richText";

const Media: React.FC<Props> = ({ slice }) => {
  const { image, imageMobile } = slice.primary;

  const mobile = (
    <Image
      image={imageMobile?.gatsbyImageData ? imageMobile : image}
      className="object-cover object-center h-full aspect-[10/17] md:aspect-[10/12]"
    />
  );
  const desktop = <Image image={image} className="object-cover object-center h-full aspect-[2/1]" />;

  return <Breakpoint mobile={mobile} desktop={desktop} />;
};

type Props = {
  slice:
    | Queries.TreatmentMediaBannerSliceFragment
    | Queries.TreatmentAddonMediaBannerSliceFragment
    | Queries.MarketingTreatmentMediaBannerSliceFragment
    | Queries.ContentMediaBannerSliceFragment
    | Queries.LocationMediaBannerSliceFragment
    | Queries.DentistMediaBannerSliceFragment;
};

const MediaBanner: React.FC<Props> = ({ slice }) => {
  const { title, text } = slice.primary;

  return (
    <section className="flex overflow-hidden relative flex-col justify-center items-center mx-auto aspect-[10/17] max-w-screen-max md:aspect-[10/12] lg:aspect-[2/1]">
      <Media slice={slice} />
      <div className="p-t-md-fluid p-b-md-fluid absolute bottom-0 left-0 lg:baseGrid lg:!px-[96px] lg:!py-[93px]">
        <section
          className={twJoin(
            "p-t-lg-fluid p-b-md-fluid col-span-full mx-5 grid flex-col justify-between rounded-xl bg-white px-8 shadow-bottom",
            "lg:p-t-sm-fluid md:mx-11 lg:col-span-13 lg:col-start-2 lg:mx-0 lg:flex xl:col-span-11 xl:col-start-2",
          )}
        >
          <RichText data={title?.richText} className="block font-medium m-b-sm-fluid" />
          <RichText data={text?.richText} className="block mb-2 typo-base styled-list text-black/70" />
        </section>
      </div>
    </section>
  );
};

export const query = graphql`
  fragment LocationMediaBannerSlice on PrismicLocationDataBodyMediaBanner {
    ...Slice

    primary {
      title: media_banner_title {
        ...RichText
      }
      text: media_banner_text {
        ...RichText
      }
      image: media_banner_image {
        alt
        gatsbyImageData(height: 1100, placeholder: DOMINANT_COLOR)
      }
      imageMobile: media_banner_mobile_image {
        alt
        gatsbyImageData(height: 1228, placeholder: DOMINANT_COLOR)
      }
    }
  }

  fragment ContentMediaBannerSlice on PrismicPageContentDataBodyMediaBanner {
    ...Slice

    primary {
      title: media_banner_title {
        ...RichText
      }
      text: media_banner_text {
        ...RichText
      }
      image: media_banner_image {
        alt
        gatsbyImageData(height: 1100, placeholder: DOMINANT_COLOR)
      }
      imageMobile: media_banner_mobile_image {
        alt
        gatsbyImageData(height: 1228, placeholder: DOMINANT_COLOR)
      }
    }
  }

  fragment DentistMediaBannerSlice on PrismicPageDentistDataBodyMediaBanner {
    ...Slice

    primary {
      title: media_banner_title {
        ...RichText
      }
      text: media_banner_text {
        ...RichText
      }
      image: media_banner_image {
        alt
        gatsbyImageData(height: 1100, placeholder: DOMINANT_COLOR)
      }
      imageMobile: media_banner_mobile_image {
        alt
        gatsbyImageData(height: 1228, placeholder: DOMINANT_COLOR)
      }
    }
  }

  fragment TreatmentMediaBannerSlice on PrismicTreatmentDataBodyMediaBanner {
    ...Slice

    primary {
      title: media_banner_title {
        ...RichText
      }
      text: media_banner_text {
        ...RichText
      }
      image: media_banner_image {
        alt
        gatsbyImageData(height: 1100, placeholder: DOMINANT_COLOR)
      }
      imageMobile: media_banner_mobile_image {
        alt
        gatsbyImageData(height: 1228, placeholder: DOMINANT_COLOR)
      }
    }
  }

  fragment TreatmentAddonMediaBannerSlice on PrismicTreatmentAddonDataBodyMediaBanner {
    ...Slice

    primary {
      title: media_banner_title {
        ...RichText
      }
      text: media_banner_text {
        ...RichText
      }
      image: media_banner_image {
        alt
        gatsbyImageData(height: 1100, placeholder: DOMINANT_COLOR)
      }
      imageMobile: media_banner_mobile_image {
        alt
        gatsbyImageData(height: 1228, placeholder: DOMINANT_COLOR)
      }
    }
  }

  fragment MarketingTreatmentMediaBannerSlice on PrismicMarketingTreatmentDataBodyMediaBanner {
    ...Slice

    primary {
      title: media_banner_title {
        ...RichText
      }
      text: media_banner_text {
        ...RichText
      }
      image: media_banner_image {
        alt
        gatsbyImageData(height: 1100, placeholder: DOMINANT_COLOR)
      }
      imageMobile: media_banner_mobile_image {
        alt
        gatsbyImageData(height: 1228, placeholder: DOMINANT_COLOR)
      }
    }
  }
`;
export default MediaBanner;
